module.exports = __webpack_public_path__ + "h5/img/close.75943e6d.gif";